<template>
  <Catalogs
    title="Услуги самозанятых"
    create-text="Новая"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'WorkServiceAdd'"
    :route-edit="'WorkServiceEdit'"
    :route-view="'WorkServiceView'"
    :route-path="'/work_services'"
    :can-edit="canEditWorkServiceCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
   import Catalogs from "../Catalogs.vue";

export default {
  name: "WorkServices",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'services-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'action',
          label: "Действия",
          class: 'services-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getWorkServices(data);
    },
    canEditWorkServiceCatalogs() {
      return this.hasPermission([PERM.CATALOG_WORK_SERVICE_EDIT]);
    }
  }
}
</script>

<style>
.services-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.services-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkServices/WorkServices.vue